$('.block-product-card-featured-slider').each(function() {

	const slider = $(this);

	let opts = {
		centeredSlides: true,
		loop: true,
		navigation: {
			nextEl: slider.find('.swiper-arrow.next')[0],
			prevEl: slider.find('.swiper-arrow.prev')[0],
		},
        slidesPerView: 1.3,
        spaceBetween: 16,
		speed: 500,
        breakpoints: {
            782: {
				centeredSlides: false,
                slidesPerView: 2.33,
				spaceBetween: 30,
            }
        }
	};

	const swiper = new Swiper($(this).find('.swiper')[0], opts);

});
